export default __webpack_public_path__ + "static/media/En.13f7d22e.svg";